import { DocumentFileTableActions } from '@monorepo/shared/componentsV2/documents/DocumentFileTableActions';
import { getDocumentFolderMoveDestinations } from '@monorepo/shared/utils/documentFolderScope';
import { DocumentFileResponse, DocumentFolderScope } from 'mapistry-shared';
import React, { useCallback, useMemo } from 'react';
import { useDeleteOrganizationDocument } from '../../hooks/useDeleteOrganizationDocument';
import { useDocumentFoldersList } from '../../hooks/useDocumentFoldersList';
import { MoveOrganizationDocumentModal } from './MoveOrganizationDocumentModal';
import { RenameDocumentModal } from './RenameDocumentModal';

interface FolderDocumentsTableActionsProps {
  organizationId: string;
  document: DocumentFileResponse;
}

export function FolderDocumentsTableActions({
  organizationId,
  document,
}: FolderDocumentsTableActionsProps) {
  const { documentFolders, isLoading } = useDocumentFoldersList({
    organizationId,
  });
  const [deleter] = useDeleteOrganizationDocument({
    config: { throwOnError: true },
  });

  const moveDestinations = useMemo(
    () =>
      getDocumentFolderMoveDestinations(documentFolders ?? [], {
        id: document.folderId ?? '',
        scope: DocumentFolderScope.ORGANIZATION,
      }),
    [document.folderId, documentFolders],
  );

  const onDelete = useCallback(
    () => deleter({ organizationId, documentId: document.id }),
    [deleter, document.id, organizationId],
  );

  if (isLoading) return null;

  return (
    <DocumentFileTableActions
      document={document}
      showEditActions
      onDelete={onDelete}
      canMove={moveDestinations.length > 0}
      renderRenameModal={(onClose) => (
        <RenameDocumentModal
          organizationId={organizationId}
          document={document}
          onClose={onClose}
        />
      )}
      renderMoveModal={(onClose) => (
        <MoveOrganizationDocumentModal
          organizationId={organizationId}
          document={document}
          folders={moveDestinations}
          onClose={onClose}
        />
      )}
    />
  );
}
